import Urls, { isTest } from '../common/Urls';
import ajax from '../common/ajax';
import { appInfo } from '../appInfo';
import { getClientInfo } from '../getClientInfo';
import { formatDate, isObject } from '../utils';
import { $pageId } from './share';
export var ymstockLog = {
    uploadCount: 0,
    pageView: function (options) {
        var requestUrl = isTest
            ? 'http://192.168.8.198:808/userasy/action/AddPage'
            : Urls.DOMAIN_MLOG + "/ub2/action/AddPage";
        var currentDate = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
        this.uploadLog(requestUrl, {
            TargetView: options.pageId,
            SourceView: options.pageId,
            EnterTime: currentDate,
            QuitTime: currentDate,
            Duration: 0,
            Attribute: isObject(options.pageData) ? JSON.stringify(options.pageData) : options.pageData
        });
    },
    click: function (options) {
        var requestUrl = isTest
            ? 'http://192.168.8.198:808/userasy/action/addevent'
            : Urls.DOMAIN_MLOG + "/ub2/action/addevent";
        var currentDate = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
        var pageId = options.pageId || $pageId;
        var eventId = options.eventId;
        if (eventId.indexOf(pageId) !== 0) {
            eventId = pageId + ":" + eventId;
        }
        this.uploadLog(requestUrl, {
            ClickCount: 0,
            EventId: eventId,
            EventDate: currentDate,
            Attribute: isObject(options.eventData) ? JSON.stringify(options.eventData) : options.eventData
        });
    },
    uploadLog: function (url, data) {
        var _this = this;
        getClientInfo({
            callGetAppInfo: true,
            success: function () {
                _this.uploadLogApi(url, data);
            },
            error: function () {
                if (_this.uploadCount <= 5) {
                    setTimeout(function () {
                        _this.uploadCount++;
                        _this.uploadLog(url, data);
                    }, 1000);
                }
            }
        });
    },
    uploadLogApi: function (url, data) {
        var params = Object.assign({
            //用户id
            UserId: appInfo.getParam('userId'),
            //硬件码
            HardwareCode: appInfo.getParam('hardwareCode'),
            //软件版本
            Version: appInfo.appVersion,
            //sdk 版本
            SystemVersion: appInfo.getParam('systemVersion'),
            //产品号
            ProductId: appInfo.productId,
            //平台号
            PlatformId: appInfo.getParam('ar')
        }, data);
        ajax({
            url: url,
            data: params,
            type: 'post',
            success: function () {
                console.info("\u7ECF\u5178\u7248\u6253\u70B9\u4E0A\u4F20\u6210\u529F\uFF1A", data);
            },
            error: function (error) {
                console.info("\u7ECF\u5178\u7248\u6253\u70B9\u4E0A\u4F20\u5931\u8D25\uFF1A", error, data);
            }
        });
    }
};
//# sourceMappingURL=ymstockLog.js.map